import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProfileChip } from "./ProfileChip";

interface ChipItem {
  id: number | string;
  label: string;
}

interface CollapsibleChipsProps {
  items: ChipItem[];
  /** Quantidade exibida antes de "ver mais". */
  maxVisible: number;
  emptyLabel: string;
}

/** Lista de chips com expansão "+N / Ocultar". */
export function CollapsibleChips({ items, maxVisible, emptyLabel }: CollapsibleChipsProps) {
  const [expandido, setExpandido] = useState(false);

  if (items.length === 0) {
    return <span className="text-sm italic text-muted-foreground">{emptyLabel}</span>;
  }

  const visiveis = expandido ? items : items.slice(0, maxVisible);
  const ocultos = items.length - visiveis.length;
  const podeRecolher = expandido && items.length > maxVisible;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {visiveis.map((item) => (
        <ProfileChip key={item.id}>{item.label}</ProfileChip>
      ))}

      {ocultos > 0 && (
        <Button
          variant="ghost"
          size="sm"
          className="h-6 px-2 text-xs text-muted-foreground hover:text-foreground"
          onClick={() => setExpandido(true)}
        >
          +{ocultos} <ChevronDown className="ml-0.5 h-3 w-3" />
        </Button>
      )}

      {podeRecolher && (
        <Button
          variant="ghost"
          size="sm"
          className="h-6 px-2 text-xs text-muted-foreground hover:text-foreground"
          onClick={() => setExpandido(false)}
        >
          Ocultar <ChevronUp className="ml-0.5 h-3 w-3" />
        </Button>
      )}
    </div>
  );
}
